// Backend sentinel meaning "never practiced". `daysSinceLastPracticed`
// returns this when there is no practice-session row at all.
const NEVER_PRACTICED_SENTINEL = 999;

const DAYS_PER_WEEK = 7;
const DAYS_PER_MONTH = 30;
const DAYS_PER_YEAR = 365;

export function relativeDate(days: number | null | undefined): string {
  if (days == null) return '—';
  if (days >= NEVER_PRACTICED_SENTINEL) return 'Never practiced';
  if (days <= 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < DAYS_PER_WEEK) return `${days} days ago`;
  if (days < DAYS_PER_MONTH) {
    const weeks = Math.floor(days / DAYS_PER_WEEK);
    return weeks === 1 ? '1 week ago' : `${weeks} weeks ago`;
  }
  if (days < DAYS_PER_YEAR) {
    const months = Math.floor(days / DAYS_PER_MONTH);
    return months === 1 ? '1 month ago' : `${months} months ago`;
  }
  return 'over a year ago';
}
